import "./polyfills";
import React from "react";
import { createRoot } from 'react-dom/client';
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom"; 
import "./assets/base.scss";
import Main from "./pages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import { AuthProvider } from "./common/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const store = configureStore();
const rootElement = document.getElementById("root");


const renderApp = (Component) => (
  <Provider store={store}>
    <AuthProvider>
      <BrowserRouter> 
        <Component />
<ToastContainer
  position="top-center"
  autoClose={4000}
  hideProgressBar={false}
  newestOnTop={true}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss={false}
  draggable
  pauseOnHover
  limit={1}
  preventDuplicates // <-- This will prevent duplicates with the same content
/>
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);

const root = createRoot(rootElement).render(renderApp(Main));

if (module.hot) {
  module.hot.accept("./pages/Main", () => {
    const NextApp = require("./pages/Main").default;
    root.render(renderApp(NextApp));
  });
}

serviceWorker.unregister();